var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row row-top"},[_c('div',{staticClass:"col-sm-12"},[_c('RoleListTable')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }